import React from "react";
import { Flame, Landmark } from "lucide-react";

export const istDateTime = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true }) : "-");

// Temple header for 72 mm thermal slips: logos, Telugu name (Dhurjati), English name, place.
export function SlipHeader({ temple }) {
  const logo = (src, Icon) => (src
    ? <img src={src} alt="" style={{ width: "13mm", height: "13mm", objectFit: "contain" }} />
    : <Icon style={{ width: "10mm", height: "10mm" }} />);
  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: "1.5mm" }}>
        {logo(temple?.logo, Landmark)}
        <div style={{ flex: 1, textAlign: "center" }}>
          {temple?.name_telugu
            ? <p className="font-telugu" style={{ fontSize: temple.name_telugu.length > 34 ? "16px" : temple.name_telugu.length > 24 ? "17.5px" : "19px", lineHeight: 1.05, margin: 0 }}>{temple.name_telugu}</p>
            : <p style={{ fontSize: "12px", fontWeight: 800, lineHeight: 1.2, margin: 0, textTransform: "uppercase" }}>{temple?.name || "Temple"}</p>}
        </div>
        {logo(temple?.logo_right, Flame)}
      </div>
      {temple?.name_telugu && (
        <p style={{ textAlign: "center", fontSize: "10.5px", fontWeight: 800, letterSpacing: "0.3px", lineHeight: 1.2, margin: "1mm 0 0", textTransform: "uppercase" }}>{temple?.name}</p>
      )}
      {temple?.location && <p style={{ textAlign: "center", fontSize: "8px", letterSpacing: "2px", textTransform: "uppercase", margin: "0.5mm 0 0" }}>{temple.location}</p>}
      <div style={{ borderTop: "1px dashed #444", margin: "1.5mm 0" }} />
    </>
  );
}

// Annaprasadam access ticket for 72-80 mm thermal printers (also prints fine on A4).
export default function AnnaTicketSlip({ ticket: t, temple }) {
  return (
    <div className="print-area bg-white text-black mx-auto" style={{ width: "72mm", padding: "3mm 2.5mm", fontFamily: "system-ui, sans-serif" }} data-testid="anna-slip">
      <SlipHeader temple={temple} />
      <p style={{ textAlign: "center", fontSize: "11.5px", fontWeight: 800, letterSpacing: "0.5px", margin: 0 }}>ANNAPRASADAM ACCESS TICKET</p>
      <div style={{ display: "flex", justifyContent: "center", gap: "4mm", margin: "2mm 0" }}>
        {t.photo
          ? <img src={t.photo} alt="" style={{ width: "22mm", height: "22mm", objectFit: "cover", border: "1px solid #444", borderRadius: "4px" }} />
          : <div style={{ width: "22mm", height: "22mm", border: "1px dashed #888", borderRadius: "4px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "8px" }}>NO PHOTO</div>}
        {t.qr_data_url && <img src={t.qr_data_url} alt="" style={{ width: "22mm", height: "22mm", border: "1px solid #444", borderRadius: "4px", imageRendering: "pixelated" }} />}
      </div>
      <div style={{ border: "1px solid #444", borderRadius: "5px", padding: "1.5mm 2mm", fontSize: "11px", lineHeight: 1.45 }}>
        <p style={{ textAlign: "center", fontWeight: 800, fontSize: "12px", margin: "0 0 1mm", textTransform: "uppercase" }}>{t.ticket_type_name}</p>
        <p style={{ margin: 0 }}><b>Ticket No:</b> <span style={{ fontFamily: "monospace", fontWeight: 800, fontSize: "12px", letterSpacing: "-0.2px" }}>{t.ticket_no}</span></p>
        <p style={{ margin: 0 }}><b>Category:</b> {t.category_name}</p>
        <p style={{ margin: 0 }}><b>Date &amp; Time:</b> {istDateTime(t.created_at)}</p>
        {t.counter_name && <p style={{ margin: 0 }}><b>Counter:</b> {t.counter_name}</p>}
        {t.shift_name && <p style={{ margin: 0 }}><b>Shift:</b> {t.shift_name}</p>}
      </div>
      <div style={{ borderTop: "1px dashed #999", marginTop: "1.5mm", paddingTop: "1mm", fontSize: "10px" }}>
        <b>📌 Instructions</b>
        <ol style={{ margin: 0, paddingLeft: "4.5mm", lineHeight: 1.35, listStyleType: "decimal" }}>
          <li>Valid for One Person Only</li>
          <li>Valid Today Only</li>
          <li>Single Entry Pass</li>
          <li>Please Show This Pass at the Dining Hall Gate</li>
          <li>Kindly Follow Staff Directions and Instructions</li>
        </ol>
      </div>
      <div style={{ borderTop: "1px dashed #999", marginTop: "1.5mm", paddingTop: "1mm", fontSize: "10px" }}>
        <p style={{ margin: 0 }}><b>Issued By:</b> {t.issued_by}</p>
        <p style={{ margin: "1mm 0 0", textAlign: "center", fontSize: "9px", fontStyle: "italic" }}>Designed &amp; Developed by <b>Aatreya Infotech Systems LLP</b></p>
      </div>
    </div>
  );
}
